import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const loggedIn = localStorage.getItem("token");

  const location = useLocation();
  if (!loggedIn) {
    return <Navigate to={"/admin/login"} state={location.pathname} replace />;
  }
  return children;
};

export default PrivateRoute;
